import { del, get, patch, post, put } from "./api_helper"
import * as url from "./url_helper"


// get Publicações Pendentes
export const getPublicacaoPendentes = (filtros, page, pageSize) => {
  const empresa = filtros?.Empresa ? `?empresa=${encodeURIComponent(filtros.Empresa)}` : ""
  return get(
    `${url.GET_PUBLICACOES_PENDENTES}/${filtros.Status}/${filtros.Prioridade}/${filtros.Data}/${page}/${pageSize}${empresa}`,
    filtros
  )
}
export const getPublicacao = cnj => post(`${url.GET_PUBLICACAO}/cnj`, cnj)

// get Processo Completo
export const getProcessoCompleto = id =>
  get(`${url.GET_PROCESSO_COMPLETO}/${id}`)

export const getMonitored = (page, limit, filters = {}) => {
  const params = new URLSearchParams({ page, limit })

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      params.append(key, value)
    }
  })

  return get(`${url.GET_MONITORED}?${params.toString()}`)
}

// update Publicação
export const updatePublicacao = publicacao =>
  put(`${url.UPDATE_PUBLICACAO}/${publicacao.Id}`, publicacao)

export const postProcesso = processo => post(`${url.POST_PROCESSO}`, processo)

// update Processo
export const updateProcesso = processo =>
  put(`${url.UPDATE_PROCESSO}/${processo.Id}`, processo)

// POST RELETED PROCESS
export const postReletedProcess = processos =>
  post(`${url.POST_RELETED}`, { processos })
// suggest companies (auto-complete)
export const suggestCompanies = query =>
  get(`${url.GET_SUGGEST_COMPANIES}?q=${encodeURIComponent(query)}`)

// get Leads Enviados
export const getLeadsEnviados = leads =>
  get(`${url.GET_LEADS_ENVIADOS}/`, leads)

// register Lead
export const createLead = lead => post(url.CREATE_UPDATE_LEAD, lead)

// update Lead
export const updateLead = lead =>
  put(`${url.CREATE_UPDATE_LEAD}/${lead.Id}`, lead)


export const sendLead = lead => {
  const destino = (lead?.Destino || "pottencial").toLowerCase()

  const idsUri = encodeURIComponent(JSON.stringify([lead.Id]))
  const query = `?destino=${encodeURIComponent(destino)}`
  return get(`${url.SEND_LEAD_CUSTOMER}/${idsUri}${query}`, lead)
}



// register Apolice
export const createApolice = apolice => post(url.CREATE_UPDATE_APOLICE, apolice)

// update Apolice
export const updateApolice = apolice =>
  put(`${url.CREATE_UPDATE_APOLICE}/${apolice.Id}`, apolice)

// delete Apolice
export const deleteApolice = apolice =>
  del(`${url.CREATE_UPDATE_APOLICE}/${apolice.Id}`)

// Login Method
export const postJwtLogin = data => post(url.POST_JWT_LOGIN, data) // Chamar novo Serviço de Autenticação  ***************

export const postJwtRegister = data => post(url.POST_JWT_REGISTER, data)

export const postJwtForgetPwd = data => post(url.POST_JWT_PASSWORD_FORGET, data)

export const postJwtResetPwd = data => post(url.POST_JWT_PASSWORD_RESET, data)

export const getMe = () => get(url.GET_ME)

export const changePassword = data => put(url.PUT_CHANGE_PASSWORD, data)

export const getUsuarios = () => get(url.GET_USERS)

export const addUsuario = data => post(url.ADD_NEW_USER, data)

export const updateUsuario = (id, data) => put(`${url.UPDATE_USER}/${id}`, data)

export const toggleUsuarioStatus = id => patch(`${url.TOGGLE_USER_STATUS}/${id}/status`, {})

// SOLUCIONARE
export const getMovementsSolucionare = () => get(url.GET_SOLUCIONARE_MOVEMENTS)
export const getProgressByCNJSolucionare = cnj =>
  get(`${url.GET_SOLUCIONARE_PROGRESS_CNJ}/${cnj}`)
